import React from 'react';
import CategoryPageFactory from './components/CategoryPageFactory';
import { CATEGORY_TYPES } from './config/categoryTypes';
import { useCategory, useCategoryServices } from './hooks/useCategoryHooks';

const WeddingServicesPageModular = () => {
  const { config, isLoading: configLoading, error: configError } = useCategory(CATEGORY_TYPES.WEDDING);
  const { services, isLoading: servicesLoading, error: servicesError } = useCategoryServices(CATEGORY_TYPES.WEDDING);

  const handleBookNow = (service) => {
    console.log('Book now clicked for:', service.title);
    // Navigate to booking page with service details
    // navigate(`/booking?service=${service.id}&category=wedding`);
  };

  const handleLearnMore = (service) => {
    console.log('Learn more clicked for:', service.title);
    // Navigate to service detail page
    // navigate(`/services/details/${service.id}`);
  };

  if (configError || servicesError) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Error Loading Page</h2>
          <p className="text-gray-600">{configError || servicesError}</p>
        </div>
      </div>
    );
  }

  return (
    <CategoryPageFactory
      categoryConfig={config}
      services={services}
      isLoading={configLoading || servicesLoading}
      onBookNow={handleBookNow}
      onLearnMore={handleLearnMore}
    />
  );
};

export default WeddingServicesPageModular;
